import { useCallback } from "react";
import { useSendEvent } from "@/components/search/GlobalSearch/hooks/useSendEvent";
import { mainBus, QueryType } from "@/common/buses";
import { apiSearch } from "@/common/services";
import { isAuthenticated } from "@/common/services/Auth";

interface IHandleClickArgs {
  historyType: string;
  historyValue: string;
  metricType: QueryType;
  metricValue: string;
}

export const useSearchResult = () => {
  const { sendQuerySubmitted } = useSendEvent();

  const onSendMetric = useCallback((type: QueryType, value: string, itemId: string) => {
    sendQuerySubmitted([value], type, itemId);
  }, [sendQuerySubmitted]);

  const onAddToHistory = useCallback(async (type: string, value: string) => {
    if (!(await isAuthenticated())) {
      return;
    }

    try {
      await apiSearch.addHistorySearchItem({ type, value });
    } catch (err) {
      console.error(err);
    }
  }, []);

  const onCloseSearch = useCallback(() => {
    mainBus.emit("close_search");
  }, []);

  const handleClick = useCallback(({
    historyType,
    historyValue,
    metricType,
    metricValue,
  }: IHandleClickArgs) => {
    onAddToHistory(historyType, historyValue);
    onSendMetric(metricType, metricValue, historyValue);
    onCloseSearch();
  }, [onAddToHistory, onSendMetric, onCloseSearch]);

  return { handleClick };
};
